import type { ComponentProps } from 'react';
import { cn } from '../../lib';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { useFieldContext } from './form-context';

export const FormTextField = ({
  className,
  label,
  ...inputProps
}: { className?: string; label: string } & ComponentProps<typeof Input>) => {
  const field = useFieldContext<string>();
  const hasError = field.getMeta().errors && field.getMeta().errors.length > 0;

  return (
    <div className="form-group w-full">
      <Label
        htmlFor={field.name}
        className="mb-2 block font-medium text-form-primary text-sm"
      >
        {label}
      </Label>
      <Input
        id={field.name}
        className={cn('w-full border px-3 py-2', className)}
        value={field.state.value}
        onChange={(e) => field.handleChange(e.target.value)}
        onBlur={(e) => {
          field.handleBlur();
          e.stopPropagation();
          e.preventDefault();
        }}
        {...inputProps}
      />
      {hasError && (
        <span className="mt-1 text-red-500 text-xs">
          {field.getMeta().errors[0]?.message}
        </span>
      )}
    </div>
  );
};

FormTextField.displayName = 'FormTextField';
